import { RuleSearchQuestionTypeContainer } from './RuleSearchQuestionTypeContainer';
export default RuleSearchQuestionTypeContainer;
